// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"5259df3a384b2a41cac8","966":"c00b1522f61b16f6f730"}[chunkId] + ".js";
};